import "antd/es/card/style";
import _Card from "antd/es/card";
import "antd/es/space/style";
import _Space from "antd/es/space";
var _excluded = ["title", "contentTitle", "contentStatus", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { DealWithCardItem } from './utils';
import Typography from '../typography';
import './style/index';

var IglooCard = function IglooCard(props) {
  var children = props.children;

  var title = props.title,
      contentTitle = props.contentTitle,
      contentStatus = props.contentStatus,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var cardTitle = _jsx(_Space, {
    size: 8,
    children: _jsx(Typography, {
      level: "h3b",
      children: title
    })
  });

  var contentTitleDom = _jsxs(_Space, {
    size: 8,
    children: [_jsx(Typography, {
      level: "h4",
      children: contentTitle
    }), contentStatus]
  });

  return _jsx(_Card, _objectSpread(_objectSpread({
    type: "inner",
    title: cardTitle
  }, rest), {}, {
    className: classnames('igloo-form-card-container', className),
    children: _jsxs("div", {
      children: [contentTitle && _jsx("div", {
        className: "igloo-form-card-container-title",
        children: contentTitleDom
      }), DealWithCardItem(children, false)]
    })
  }));
};

IglooCard.displayName = 'IglooCard';
export default IglooCard;